import moment, { Moment } from 'moment';
import TaskActionIcon, { TaskActionIconDTO } from '../onboarding/process/action/TaskActionIcon';

export enum CalendarActionContentType {
	PAGE = 'page',
}

export interface CalendarActionDTO {
	name: string;
	calendar_action_id: string;
	content_id: string;
	content_type: CalendarActionContentType;
	active_from: string;
	active_to: string | null;
	closed_at: string | null;
	icon: TaskActionIconDTO | null;
	earnings?: Record<string, number> | null;
}

export default class CalendarAction {
	public readonly name: string;
	public readonly calendarActionId: string;
	public readonly contentId: string;
	public readonly contentType: string;
	public readonly activeFrom: Moment;
	public readonly activeTo: Moment | null;
	public readonly closedAt: Moment | null;
	public readonly icon: TaskActionIcon | null;
	public readonly earnings?: Record<string, number> | null;

	constructor(calendarActionDTO: CalendarActionDTO) {
		this.name = calendarActionDTO.name;
		this.calendarActionId = calendarActionDTO.calendar_action_id;
		this.contentId = calendarActionDTO.content_id;
		this.contentType = calendarActionDTO.content_type;
		this.activeFrom = moment(calendarActionDTO.active_from);
		this.activeTo = !!calendarActionDTO.active_to ? moment(calendarActionDTO.active_to) : null;
		this.closedAt = !!calendarActionDTO.closed_at ? moment(calendarActionDTO.closed_at) : null;
		this.icon = calendarActionDTO.icon ? new TaskActionIcon(calendarActionDTO.icon) : null;
		this.earnings = calendarActionDTO.earnings;
	}
}
